export default {
  setMelhorEnvioEnabledIntegration(state, data) {
    state.melhorEnvioEnabledIntegration = data || {};
  },
};
